import isPropValid from "@emotion/is-prop-valid";
import boxMixin from "@mittwald/flow-components/dist/mixins/box";
import { color, size } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import { AvatarItemText } from "./AvatarItemText";
import { AvatarOverlay } from "./AvatarOverlay";
import { Icon } from "./Icon";
import { IconItemText } from "./IconItemText";
export const Item = styled.a.withConfig({
    shouldForwardProp: isPropValid,
}) `
  ${boxMixin};
  cursor: pointer;
  border-radius: ${size.borderRadius};

  &.condensedAvatar {
    border-radius: 50%;
  }

  &:hover:not(.active),
  &.hover:not(.active) {
    &:not(.condensedAvatar) {
      background-color: ${color.background.selectableBox.hovered};
    }

    ${IconItemText},
    ${AvatarItemText} {
      color: ${color.brand.primary.default};
    }

    &.condensedAvatar {
      ${AvatarOverlay} {
        background-color: rgba(0, 0, 0, 0.2);
      }
    }
  }

  &.active {
    &:not(.condensedAvatar) {
      background-color: ${color.background.selectableBox.selected};
    }

    ${IconItemText},
    ${AvatarItemText} {
      font-weight: bold;
      color: ${color.font.link.default};
    }

    ${Icon} {
      color: ${color.font.link.default};
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSXRlbS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL01haW5OYXZpZ2F0aW9uL3N0eWxlZC9JdGVtLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sV0FBVyxNQUFNLHdCQUF3QixDQUFDO0FBQ2pELE9BQU8sUUFFTixNQUFNLDJDQUEyQyxDQUFDO0FBQ25ELE9BQU8sRUFBRSxLQUFLLEVBQUUsSUFBSSxFQUFFLE1BQU0sZ0RBQWdELENBQUM7QUFDN0UsT0FBTyxNQUFNLE1BQU0sbUJBQW1CLENBQUM7QUFDdkMsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLGtCQUFrQixDQUFDO0FBQ2xELE9BQU8sRUFBRSxhQUFhLEVBQUUsTUFBTSxpQkFBaUIsQ0FBQztBQUNoRCxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sUUFBUSxDQUFDO0FBQzlCLE9BQU8sRUFBRSxZQUFZLEVBQUUsTUFBTSxnQkFBZ0IsQ0FBQztBQUU5QyxNQUFNLENBQUMsTUFBTSxJQUFJLEdBQUcsTUFBTSxDQUFDLENBQUMsQ0FBQyxVQUFVLENBQUM7SUFDdEMsaUJBQWlCLEVBQUUsV0FBVztDQUMvQixDQUFDLENBQWU7SUFDYixRQUFROzttQkFFTyxJQUFJLENBQUMsWUFBWTs7Ozs7Ozs7OzBCQVNWLEtBQUssQ0FBQyxVQUFVLENBQUMsYUFBYSxDQUFDLE9BQU87OztNQUcxRCxZQUFZO01BQ1osY0FBYztlQUNMLEtBQUssQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLE9BQU87Ozs7UUFJbEMsYUFBYTs7Ozs7Ozs7MEJBUUssS0FBSyxDQUFDLFVBQVUsQ0FBQyxhQUFhLENBQUMsUUFBUTs7O01BRzNELFlBQVk7TUFDWixjQUFjOztlQUVMLEtBQUssQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLE9BQU87OztNQUdoQyxJQUFJO2VBQ0ssS0FBSyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsT0FBTzs7O0NBR3JDLENBQUMifQ==